'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../dist-es6/client/formatters');
const PseudoGroup=require('../../../dist-es6/client/domain/pseudoGroup');
const GroupStatisticsViewModel=require('../../../dist-es6/client/viewModels/groupStatisticsViewModel');let

HeatmapGroupViewModel=class HeatmapGroupViewModel extends GroupStatisticsViewModel{
constructor(...args){
super(...args);

this._colSpan=1;
}

static cloneFromGroupStatisticsViewModel(groupStatisticsViewModel){
const{
_id,
_name,
_aggregatePersons,
_directPersons,
_numTripsOnDuty,
_numPersonsOnDuty,
_maxFatigueOnDuty,
_maxLastKnownFatigue,
_averageHoursOfSleepPerDay,
_averageFatigueOnDuty,
_fatigueThreshold,
_deviationThreshold,
_percentOverThresholdCache}=
groupStatisticsViewModel;

const vm=new HeatmapGroupViewModel(
_id,
_name,
_aggregatePersons,
_directPersons,
_numTripsOnDuty,
_numPersonsOnDuty,
_maxFatigueOnDuty,
_maxLastKnownFatigue,
_averageHoursOfSleepPerDay,
_averageFatigueOnDuty,
_fatigueThreshold,
_deviationThreshold,
_percentOverThresholdCache,!1);



vm.children=groupStatisticsViewModel.children.map(HeatmapGroupViewModel.cloneFromGroupStatisticsViewModel)||[];

return vm;
}

get colSpan(){
return this._colSpan;
}

set colSpan(colSpan){
this._colSpan=colSpan;
}

get children(){
return this._children;
}

set children(children){
_.ensureInstanceOf(Array,children);
children.forEach(c=>_.ensureInstanceOf([HeatmapGroupViewModel,GroupStatisticsViewModel,PseudoGroup],c));

this._children=children;
}};


module.exports=HeatmapGroupViewModel;
//# sourceMappingURL=heatmapGroupViewModel.js.map
